import { useGetCampaignDetailQuery } from '../redux/collaborationsApi'

export const useCampaignDetail = (campaignId: string | undefined) => {
  const { data, isLoading, error, refetch } = useGetCampaignDetailQuery(campaignId!, {
    skip: !campaignId,
    refetchOnMountOrArgChange: true,
  })

  return {
    campaign: data,
    isLoading,
    error: error ? (error as any).data?.error || 'Failed to fetch campaign detail' : null,
    refetch,
  }
}
